import React, { useEffect, useState } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import './modal.scss';
import { DragDropContext, Draggable, DraggableProvided, DraggableRubric, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { StrictModeDroppable } from './StringModeDroppable';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { PiArrowsOutCardinal } from "react-icons/pi";
import { IoMdLock } from "react-icons/io";

interface IConfigureTableModalProps {
  initialItems: IItem[];
  show: boolean;
  setShow: (prop: boolean) => void;
  setTableColumns: (prop: IItem[]) => void;
}

export interface IItem {
  id: string;
  content?: string;
  show: boolean;
}

function ConfigureTableModal({ show, setShow, initialItems, setTableColumns }: IConfigureTableModalProps) {
  const [items, setItems] = useState(initialItems);

  const handleDragEnd = (result: any) => {
    if (!result.destination) return; // dropped outside the list
    const movedItem = items[result.source.index];
    const newItems = [...items];
    newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, movedItem);
    setItems(newItems);
  };

  const getRenderItem = (items: IItem[]) => (provided: DraggableProvided, snapshot: DraggableStateSnapshot, rubric: DraggableRubric) => {
    const alwaysShow = ["item-0", "item-2", "item-4"]

    var transform = provided.draggableProps.style?.transform
    if (transform && provided.draggableProps.style) {
      var t = transform.split(",")[1]
      provided.draggableProps.style.transform = "translate(0px," + t // dnd apenas vertical
    }

    return (
      <div
        {...provided.draggableProps}
        // {...provided.dragHandleProps}
        ref={provided.innerRef}
        style={{
          userSelect: 'none',
          padding: 12,
          margin: '0 0 8px 0',
          width: '100%',
          background: "white",
          borderRadius: "8px",
          border: snapshot.isDragging ? "1px solid #d7d7d7" : "1px solid #CCCBCC",
          ...provided.draggableProps.style,
        }}
      >
        <div style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center'
        }}>
          <span
            onClick={() => {
              if (alwaysShow.findIndex(showItem => showItem === items[rubric.source.index].id) !== -1) return
              setItems(items.map(item =>
                item.id === items[rubric.source.index].id
                  ? { ...item, show: !items[rubric.source.index].show }
                  : item
              ))
            }}
            style={{
              fontSize: '20px',
              display: 'flex',
              alignItems: 'center',
              cursor: alwaysShow.findIndex(showItem => showItem === items[rubric.source.index].id) === -1 ? 'pointer' : ''
            }}
          >
            {alwaysShow.findIndex(showItem => showItem === items[rubric.source.index].id) === -1
              ? items[rubric.source.index].show
                ? <BsEye style={{ color: "#4EA54C" }} />
                : <BsEyeSlash style={{ color: "#FC0027" }} />
              : <IoMdLock style={{ color: "#8d8d8d" }} />}
          </span>
          <span style={{
            color: '#424242',
            fontSize: '14px',
            fontWeight: 400,
            width: '100%'
          }}>
            {items[rubric.source.index].content}
          </span>
          <span
            {...provided.dragHandleProps}
            style={{
              color: '#005EAD',
              fontSize: '24px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'grab',
              // cursor: '-moz-grab',
            }}
          >
            <PiArrowsOutCardinal />
          </span>
        </div>
      </div>
    )
  };

  return (
    <>
      <Modal
        open={show}
        onClose={() => setShow(false)}
        showCloseIcon={false}
        center
      >
        <div className='configure-table-modal-body'>
          <span className='title'>Configurar Tabela</span>

          <div className='table-columns'>
            <DragDropContext onDragEnd={handleDragEnd}>
              <StrictModeDroppable
                droppableId="droppable"
                renderClone={getRenderItem(items)}
                direction='vertical'
              >
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {items.map((item, index) => (
                      <Draggable key={item.id} draggableId={item.id} index={index}>
                        {getRenderItem(items)}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </StrictModeDroppable>
            </DragDropContext>
          </div>

          <div className='actions-buttons'>
            <button
              className='cancel'
              onClick={() => setShow(false)}
            >
              Voltar
            </button>
            <button
              className='save'
              onClick={() => {
                setTableColumns(items)
                localStorage.setItem('@Zignet:tabela-debitos', JSON.stringify(items));
                setShow(false)
              }}
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ConfigureTableModal;

